import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-start_live",
  "use": "icon-start_live-usage",
  "viewBox": "0 0 8.513 9.563",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8.513 9.563\" id=\"icon-start_live\"><defs><style>#icon-start_live .a{fill:#2dcab5;}</style></defs><path class=\"a\" d=\"M161.2,121.638v-7.819a.871.871,0,0,1,1.307-.754l6.77,3.909a.871.871,0,0,1,0,1.509l-6.772,3.909A.871.871,0,0,1,161.2,121.638Z\" transform=\"translate(-161.2 -112.947)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol